export const isBlank = (value) =>
  value === null || value === undefined || String(value).trim() === '';
